import { Section, Button } from 'react-scale/components';
import SpeakerCard from 'react-scale/components/pages/transformx/speakers/speakerCard';

const Speakers = ({ data, useNewAvatar = false, showHeader = true, paddingTop = true }) => (
  <Section id="speakers" paddingTop={paddingTop}>
    <div className="relative z-20 text-center">
      {showHeader && (
        <div>
          <h3 className="text-4xl lg:text-5xl font-aeonik lg:leading-[64px] text-center md:max-w-[580px] mx-auto mt-8 lg:mt-0">
            Past Speakers
          </h3>

          <div className="flex flex-col justify-center mt-8 space-y-4 md:flex-row md:space-y-0 md: md:space-x-4 md:px-48 ">
            <div className="max-w-48">
              <Button
                text="Apply to Speak"
                variant="transformX"
                href="/events/transformx/call-for-speakers"
                fullWidth
              />
            </div>
            <div className="max-w-48">
              <Button
                text="Past Sessions"
                variant="secondary"
                href="https://exchange.scale.com/public/videos?tags=615d86be4106640013770230%2C60d07cdc4be7812f84ab27ee"
                target="_blank"
                fullWidth
              />
            </div>
          </div>
        </div>
      )}

      {/* Speakers Grid */}
      <div className="flex mt-20">
        <ul className="grid w-full gap-4 xl:grid-cols-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {data.map((speaker, idx) => (
            <SpeakerCard speaker={speaker} idx={idx} useNewAvatar={useNewAvatar} />
          ))}
        </ul>
      </div>

      {showHeader && (
        <div className="flex justify-center mt-8">
          <Button text="See all Speakers" variant="secondary" href="/events/transformx/speakers" />
        </div>
      )}
    </div>
  </Section>
);
export default Speakers;
